"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFinleyValleyBankTapes = exports.validateVanListJoin = exports.createVanListMap = exports.VanListEntityToTablenameMap = void 0;
exports.VanListEntityToTablenameMap = {
    vanCustAcctRel: 'ACCTRELATION',
};
const createVanListMap = (vanList) => {
    const vanListMap = new Map();
    vanList.forEach((el) => {
        vanListMap.set(`${el.tablename}-${el.code}`, el);
    });
    return vanListMap;
};
exports.createVanListMap = createVanListMap;
const validateVanListJoin = ({ vanListMap, vanEntity, vanListCodes, }) => {
    const logs = new Map();
    const tablename = exports.VanListEntityToTablenameMap[vanEntity];
    vanListCodes.forEach((code) => {
        if (!vanListMap.has(`${tablename}-${code}`)) {
            logs.set(`${tablename}-${code}`, {
                level: 'warning',
                file: vanEntity,
                column: 'tablename-code',
                identifier: `${tablename}-${code}`,
                message: `Failed to join [vanEntity:${vanEntity}] to VanList for [tablename:${tablename}] [code:${code}].`,
            });
        }
    });
    return Array.from(logs.values());
};
exports.validateVanListJoin = validateVanListJoin;
const validateVanDepAcctCifNumJoins = ({ vanCust, vanDepAcct, }) => {
    const cifNums = new Set(vanCust.map(({ cif_num }) => cif_num));
    const logs = [];
    vanDepAcct.forEach((acct) => {
        if (!cifNums.has(acct.cif_num)) {
            logs.push({
                level: 'warning',
                file: 'VanDepAcct',
                column: 'account_id',
                identifier: acct.account_id,
                message: `VanDeptAcct [account_id:${acct.account_id}] is associated with an unknown [cif_num:${acct.cif_num}]`,
            });
        }
    });
    return logs;
};
/**
 * Validates joins that are not explicitly done via filter set.
 */
const validateJoins = (finleyValleyBankTapes) => {
    const logs = [];
    const { vanCustAcctRel, vanList, vanCust, vanDepAcct, } = finleyValleyBankTapes;
    const vanListMap = (0, exports.createVanListMap)(vanList);
    const vanCustAcctRelToVanListJoinErrors = (0, exports.validateVanListJoin)({
        vanListMap,
        vanEntity: 'vanCustAcctRel',
        vanListCodes: vanCustAcctRel.map(({ rel_code }) => rel_code),
    });
    vanCustAcctRelToVanListJoinErrors.forEach((log) => {
        logs.push(log);
    });
    const invalidVanDepAcctCifNumsLogs = validateVanDepAcctCifNumJoins({
        vanDepAcct,
        vanCust,
    });
    invalidVanDepAcctCifNumsLogs.forEach((log) => {
        logs.push(log);
    });
    return logs;
};
const validateVanListUniqueness = (vanList) => {
    const logs = [];
    const seen = new Set();
    vanList.forEach((list) => {
        const key = `${list.tablename}-${list.code}`;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'VanList',
                column: 'tablename-code',
                identifier: `${list.tablename}-${list.code}`,
                message: `Duplicate VanList record detected for [tablename:${list.tablename}] [code:${list.code}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validateVanProductUniqueness = (vanProduct) => {
    const logs = [];
    const seen = new Set();
    vanProduct.forEach((product) => {
        const key = product.product_code;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'VanProduct',
                column: 'product_code',
                identifier: product.product_code,
                message: `Duplicate VanProduct record detected for [product_code:${product.product_code}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validateVanCustUniqueness = (vanCust) => {
    const logs = [];
    const seen = new Set();
    vanCust.forEach((cust) => {
        const key = cust.cif_num;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'VanCust',
                column: 'cif_num',
                identifier: cust.cif_num,
                message: `Duplicate VanCust record detected for [cif_num:${cust.cif_num}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validateVanCustAcctRelUniqueness = (vanCustAcctRel) => {
    const logs = [];
    const seen = new Set();
    vanCustAcctRel.forEach((rel) => {
        const key = `${rel.account_id}-${rel.cif_num}-${rel.app_code}`;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'VanCustAcctRel',
                column: 'account_id',
                identifier: rel.account_id,
                message: `Duplicate VanCustAcctRel record detected for [account_id:${rel.account_id}] [cif_num:${rel.cif_num}] [app_code:${rel.app_code}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validateVanDepAcctUniqueness = (vanDepAcct) => {
    const logs = [];
    const seen = new Set();
    vanDepAcct.forEach((acct) => {
        const key = acct.account_id;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'VanDepAcct',
                column: 'account_id',
                identifier: acct.account_id,
                message: `Duplicate VanDepAcct record detected for [account_id:${acct.account_id}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validateLoanCustRelUniqueness = (loanCustRel) => {
    const logs = [];
    const seen = new Set();
    loanCustRel.forEach((rel) => {
        // ignore null portfolio numbers
        if (rel.helcrel_portfolio_number) {
            const key = `${rel.heloan_acct_num}-${rel.helcrel_portfolio_number}-${rel.helcrel_acct_type}`;
            if (seen.has(key)) {
                logs.push({
                    level: 'error',
                    file: 'LoanCustRel',
                    column: 'heloan_acct_num',
                    identifier: rel.heloan_acct_num,
                    message: `Duplicate LoanCustRel record detected for [heloan_acct_num:${rel.heloan_acct_num}] [helcrel_portfolio_number:${rel.helcrel_portfolio_number}] [helcrel_acct_type:${rel.helcrel_acct_type}]`,
                });
            }
            else {
                seen.add(key);
            }
        }
    });
    return logs;
};
const validateCuoDepositUniqueness = (cuoDeposit) => {
    const logs = [];
    const seen = new Set();
    cuoDeposit.forEach((dep) => {
        const key = dep.hedeposit_acct_num;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'CuoDeposit',
                column: 'hedeposit_acct_num',
                identifier: dep.hedeposit_acct_num,
                message: `Duplicate CuoDeposit record detected for [hedeposit_acct_num:${dep.hedeposit_acct_num}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validateCuoCollatUniqueness = (cuoCollat) => {
    const logs = [];
    const seenHeCollId = new Set();
    const seenHecoll_deposit_account_num = new Set();
    cuoCollat.forEach((rel) => {
        // ignore null portfolio numbers
        const heCollId = rel.hecoll_id;
        const accountNumber = rel.hecoll_deposit_account_num;
        if (seenHeCollId.has(heCollId)) {
            logs.push({
                level: 'error',
                file: 'CuoCollat',
                column: 'heCollId',
                identifier: heCollId,
                message: `Duplicate CuoCollat record detected for [hecoll_id:${heCollId}]`,
            });
        }
        else {
            seenHeCollId.add(heCollId);
        }
        // ignore null account number
        if (accountNumber) {
            if (seenHecoll_deposit_account_num.has(accountNumber)) {
                logs.push({
                    level: 'error',
                    file: 'CuoCollat',
                    column: 'hecoll_deposit_account_num',
                    identifier: accountNumber,
                    message: `Duplicate CuoCollat record detected for [hecoll_deposit_account_num:${accountNumber}]`,
                });
            }
            else {
                seenHecoll_deposit_account_num.add(heCollId);
            }
        }
    });
    return logs;
};
const validateCollatCustRelUniqueness = (collatCustRel) => {
    const logs = [];
    const seen = new Set();
    collatCustRel.forEach((rel) => {
        // ignore null portfolio numbers
        if (rel.portfolio_number) {
            const key = `${rel.he_coll_id}-${rel.portfolio_number}`;
            if (seen.has(key)) {
                logs.push({
                    level: 'error',
                    file: 'CollatCustRel',
                    column: 'he_coll_id',
                    identifier: rel.he_coll_id,
                    message: `Duplicate CollatCustRel record detected for [he_coll_id:${rel.he_coll_id}] [portfolio_number:${rel.portfolio_number}]`,
                });
            }
            else {
                seen.add(key);
            }
        }
    });
    return logs;
};
const validatePsPlusPortfolioUniqueness = (psPlusPortfolio) => {
    const logs = [];
    const seen = new Set();
    psPlusPortfolio.forEach((port) => {
        const key = `${port.heccrel_portfolio_number}-${port.hecoll_id}`;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'PsPlusPortfolio',
                column: 'hecoll_id',
                identifier: port.hecoll_id,
                message: `Duplicate PsPlusPortfolio record detected for [heccrel_portfolio_number:${port.heccrel_portfolio_number}] [hecoll_id:${port.hecoll_id}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validatePsPlusAccountUniqueness = (psPlusAccount) => {
    const logs = [];
    const seen = new Set();
    psPlusAccount.forEach((account) => {
        const key = account.hecoll_id;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'PsPlusAccount',
                column: 'hecoll_id',
                identifier: account.hecoll_id,
                message: `Duplicate PsPlusAccount record detected for [hecoll_id:${account.hecoll_id}] `,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validatePsPlusSecDetailUniqueness = (psPlusSecDetail) => {
    const logs = [];
    const seen = new Set();
    psPlusSecDetail.forEach((detail) => {
        const key = `${detail.hecoll_id}-${detail.he_sec_security_num}-${detail.currency_code}`;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'PsPlusSecDetail',
                column: 'hecoll_id',
                identifier: detail.hecoll_id,
                message: `Duplicate PsPlusSecDetail record detected for [hecoll_id:${detail.hecoll_id}] [he_sec_security_num:${detail.he_sec_security_num}] [currency_code:${detail.currency_code}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validatePsPlusSecMasterUniqueness = (psPlusSecMaster) => {
    const logs = [];
    const seen = new Set();
    psPlusSecMaster.forEach((master) => {
        const key = master.he_sec_security_num;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'PsPlusSecMaster',
                column: 'he_sec_security_num',
                identifier: master.he_sec_security_num,
                message: `Duplicate PsPlusSecMaster record detected for [he_sec_security_num:${master.he_sec_security_num}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validateVanCmmtUniqueness = (vanCmmt) => {
    const logs = [];
    const seen = new Set();
    vanCmmt.forEach((cmmt) => {
        const key = cmmt.commitment_id;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'VanCmmt',
                column: 'commitment_id',
                identifier: cmmt.commitment_id,
                message: `Duplicate VanCmmt record detected for [commitment_id:${cmmt.commitment_id}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validateVanLoanAcctUniqueness = (vanLoan) => {
    const logs = [];
    const seen = new Set();
    vanLoan.forEach((loan) => {
        const key = loan.loan_id;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'VanLoan',
                column: 'loan_id',
                identifier: loan.loan_id,
                message: `Duplicate VanLoan record detected for [loan_id:${loan.loan_id}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validateCuoMaintUniqueness = (cuoMaint) => {
    const logs = [];
    const seen = new Set();
    cuoMaint.forEach((maint) => {
        const key = maint.heloan_acct_num;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'CuoMaint',
                column: 'heloan_acct_num',
                identifier: maint.heloan_acct_num,
                message: `Duplicate CuoMaint record detected for [heloan_acct_num:${maint.heloan_acct_num}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validateDerivativePathUniqueness = (derivativePath) => {
    const logs = [];
    const seen = new Set();
    derivativePath.forEach((dp) => {
        const key = dp.id;
        if (seen.has(key)) {
            logs.push({
                level: 'error',
                file: 'DerivativePath',
                column: 'id',
                identifier: dp.id,
                message: `Duplicate DerivativePath record detected for [id:${dp.id}]`,
            });
        }
        else {
            seen.add(key);
        }
    });
    return logs;
};
const validateCuoLoanUniqueness = (_cuoLoan) => []; // no uniqueness enforced on this table currently
const validateUniqueness = ({ vanCust, vanCustAcctRel, vanList, vanProduct, vanDepAcct, loanCustRel, cuoDeposit, cuoCollat, collatCustRel, psPlusAccount, psPlusPortfolio, psPlusSecDetail, psPlusSecMaster, vanCmmt, vanLoanAcct, cuoLoan, cuoMaint, derivativePath, }) => {
    const logs = [];
    const vanListLogs = validateVanListUniqueness(vanList);
    vanListLogs.forEach((log) => {
        logs.push(log);
    });
    const vanProductLogs = validateVanProductUniqueness(vanProduct);
    vanProductLogs.forEach((log) => {
        logs.push(log);
    });
    const vanCustLogs = validateVanCustUniqueness(vanCust);
    vanCustLogs.forEach((log) => {
        logs.push(log);
    });
    const vanCustAcctRelLogs = validateVanCustAcctRelUniqueness(vanCustAcctRel);
    vanCustAcctRelLogs.forEach((log) => {
        logs.push(log);
    });
    const vanDepAcctLogs = validateVanDepAcctUniqueness(vanDepAcct);
    vanDepAcctLogs.forEach((log) => {
        logs.push(log);
    });
    const loanCustRelLogs = validateLoanCustRelUniqueness(loanCustRel);
    loanCustRelLogs.forEach((log) => {
        logs.push(log);
    });
    const cuoDepositLogs = validateCuoDepositUniqueness(cuoDeposit);
    cuoDepositLogs.forEach((log) => {
        logs.push(log);
    });
    const cuoCollatLogs = validateCuoCollatUniqueness(cuoCollat);
    cuoCollatLogs.forEach((log) => {
        logs.push(log);
    });
    const collatCustRelLogs = validateCollatCustRelUniqueness(collatCustRel);
    collatCustRelLogs.forEach((log) => {
        logs.push(log);
    });
    const psPlusPortfolioLogs = validatePsPlusPortfolioUniqueness(psPlusPortfolio);
    psPlusPortfolioLogs.forEach((log) => {
        logs.push(log);
    });
    const psPlusAccountLogs = validatePsPlusAccountUniqueness(psPlusAccount);
    psPlusAccountLogs.forEach((log) => {
        logs.push(log);
    });
    const psPlusSecDetailLogs = validatePsPlusSecDetailUniqueness(psPlusSecDetail);
    psPlusSecDetailLogs.forEach((log) => {
        logs.push(log);
    });
    const psPlusSecMasterLogs = validatePsPlusSecMasterUniqueness(psPlusSecMaster);
    psPlusSecMasterLogs.forEach((log) => {
        logs.push(log);
    });
    const vanCmmtLogs = validateVanCmmtUniqueness(vanCmmt);
    vanCmmtLogs.forEach((log) => {
        logs.push(log);
    });
    const vanLoanAcctLogs = validateVanLoanAcctUniqueness(vanLoanAcct);
    vanLoanAcctLogs.forEach((log) => {
        logs.push(log);
    });
    const cuoLoanLogs = validateCuoLoanUniqueness(cuoLoan);
    cuoLoanLogs.forEach((log) => {
        logs.push(log);
    });
    const cuoMaintLogs = validateCuoMaintUniqueness(cuoMaint);
    cuoMaintLogs.forEach((log) => {
        logs.push(log);
    });
    const derivativePathLogs = validateDerivativePathUniqueness(derivativePath);
    derivativePathLogs.forEach((log) => {
        logs.push(log);
    });
    return logs;
};
const validateFinleyValleyBankTapes = (finleyValleyBankTapes) => {
    const logs = [];
    const uniquenessLogs = validateUniqueness(finleyValleyBankTapes);
    uniquenessLogs.forEach((log) => {
        logs.push(log);
    });
    const validateJoinIngestionLogs = validateJoins(finleyValleyBankTapes);
    validateJoinIngestionLogs.forEach((log) => {
        logs.push(log);
    });
    return logs;
};
exports.validateFinleyValleyBankTapes = validateFinleyValleyBankTapes;
//# sourceMappingURL=validate.js.map